// StationManager.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx-js-style";
import StationService from "../services/station_service";
import CreateInfoStationModal from "../components/create_info_station_modal";
import UpdateInfoStationModal from "../components/update_info_station_modal";
import DeleteInfoStationModal from "../components/delete_info_station_modal";
import Header from "../components/header";
import { toast } from "react-toastify";


const StationInfoScreen = () => {
    const [stations, setStations] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedStation, setSelectedStation] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchStations = async () => {
        try {
            const res = await StationService.getAllInfoStations();
            setStations(res.data);
        } catch (err) {
            console.error("Failed to fetch stations:", err);
        }
    };

    useEffect(() => {
        fetchStations();
    }, []);


    const exportSingleStation = (selectedStation) => {
        console.log(selectedStation);
        const index = stations.findIndex(st => st.station_id === selectedStation.station_id);
        console.log(index);
        const currId = selectedStation.station_id;

        let stationsToExport = [];

        let prev = stations.find(st => st.station_id === currId - 1) || null;
        let curr = stations.find(st => st.station_id === currId) || null;
        let next = stations.find(st => st.station_id === currId + 1) || null;

        if (selectedStation.zone === "SOUTH RAILWAY") {
            const temp = prev;
            prev = next;
            next = temp;
        }

        console.log(prev);
        console.log(curr);
        console.log(next);

        if (!prev || !next) {
            toast.error("Cannot export: both neighbouring stations not available");
            return;
        }

        stationsToExport.push(prev);
        stationsToExport.push(curr);
        stationsToExport.push(next);

        exportToExcel(stationsToExport, selectedStation);


        // if (prev) stationsToExport.push(prev);
        // stationsToExport.push(curr);
        // if (next) stationsToExport.push(next);

        // exportToExcel(stationsToExport, selectedStation);
    };



    const exportToExcel = (stationsToPrintInExcel = stations, actualSelectedStation) => {

        // Determine CURRENT station index from stationsToPrintInExcel
        let currIndex = 0;

        if (stationsToPrintInExcel.length === 1) {
            currIndex = 0;
        } else if (stationsToPrintInExcel.length === 2) {
            currIndex = stationsToPrintInExcel[0].station_id === actualSelectedStation.station_id ? 0 : 1;
        } else if (stationsToPrintInExcel.length === 3) {
            currIndex = 1;
        }

        // Extract only current station
        const currentStation = stationsToPrintInExcel[currIndex];

        const rows = [];

        // -------------------------
        // HEADER ROWS
        // -------------------------
        rows.push([
            "STATION NAME", "STATION ID From TOP to Bottom (Right, Center, Left)", "STATION CODE",
            "LINE NAME",
            "STATION BOUNDARY", "", "ATP TERRITORY", "",
        ]);

        rows.push([
            "", "", "",
            "", "Signal Name", "Signal Type( Entry / Exit)", "Entry/Exit", "Signal Name for Entry/Exit",
        ]);

        // -------------------------
        // DATA ROWS
        // -------------------------
        stationsToPrintInExcel.forEach(s => {
            const maxLines = Math.max(
                (s.boundaries?.length ?? 0),
                (s.atp_records?.length ?? 0),
                (s.psrs?.length ?? 0),
                1
            );

            for (let i = 0; i < maxLines; i++) {
                const b = s.boundaries?.[i] ?? {};
                const p = s.psrs?.[i] ?? {};
                const a = s.atp_records?.[i] ?? {}

                rows.push([
                    i === 0 ? s.name : "-",
                    i === 0 ? s.station_id : "-",
                    i === 0 ? s.station_code : "-",

                    b.line_name ?? "-",
                    b.signal_name ?? "-",
                    b.signal_type ?? "-",

                    a.entry_exit ?? "-",
                    a.signal_name ?? "-",
                ]);
            }
        });

        // ------------------------------------------------------
        // INSERT TOP SUMMARY BLOCK (Rows 1–7)
        // ------------------------------------------------------
        const summaryRows = [
            ["Station Name", currentStation.name || "-"],
            ["Station ID", currentStation.station_id || "-"],
            ["Station Code", currentStation.station_code || "-"],
            ["MPS (Kmph)", currentStation.speed || "130"],
            ["TAG Range", currentStation.tag_range || "-"],
            ["TIN Range", currentStation.tin_range || "-"],
            [""]
        ];

        const finalRows = [...summaryRows, ...rows];

        // -------------------------
        // CREATE WORKBOOK + FIRST SHEET
        // -------------------------
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(finalRows);
        ws["!merges"] = [];

        // -------------------------
        // HEADER MERGES (shifted)
        // -------------------------
        ws["!merges"].push(
            { s: { r: 7, c: 4 }, e: { r: 7, c: 5 } },
            { s: { r: 7, c: 6 }, e: { r: 7, c: 7 } },

            { s: { r: 7, c: 0 }, e: { r: 8, c: 0 } },
            { s: { r: 7, c: 1 }, e: { r: 8, c: 1 } },
            { s: { r: 7, c: 2 }, e: { r: 8, c: 2 } },
            { s: { r: 7, c: 3 }, e: { r: 8, c: 3 } }
        );

        // -------------------------
        // DYNAMIC MERGES FOR DATA
        // -------------------------
        let currentRow = 9;

        stationsToPrintInExcel.forEach(s => {
            const maxLines = Math.max(
                (s.boundaries?.length ?? 0),
                (s.atp_records?.length ?? 0),
                (s.psrs?.length ?? 0),
                1
            );

            const startRow = currentRow;

            if (maxLines > 1) {
                ws["!merges"].push(
                    { s: { r: startRow, c: 0 }, e: { r: startRow + maxLines - 1, c: 0 } },
                    { s: { r: startRow, c: 1 }, e: { r: startRow + maxLines - 1, c: 1 } },
                    { s: { r: startRow, c: 2 }, e: { r: startRow + maxLines - 1, c: 2 } },

                    // { s: { r: startRow, c: 6 }, e: { r: startRow + maxLines - 1, c: 6 } },
                    // { s: { r: startRow, c: 7 }, e: { r: startRow + maxLines - 1, c: 7 } },
                );
            }

            currentRow += maxLines;
        });

        // =====================================================
        //  STYLING (BORDERS + COLORS)
        // =====================================================

        const borderStyle = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
        };

        const header1Fill = { patternType: "solid", fgColor: { rgb: "F4A7B9" } };
        const header2Fill = { patternType: "solid", fgColor: { rgb: "C8E79A" } };
        const dataFill = { patternType: "solid", fgColor: { rgb: "EBD6D6" } };
        const summaryFill = { patternType: "solid", fgColor: { rgb: "FFF799" } };

        // ---- STYLE FIRST SHEET ----
        const range1 = XLSX.utils.decode_range(ws["!ref"]);

        for (let R = range1.s.r; R <= range1.e.r; R++) {
            for (let C = range1.s.c; C <= range1.e.c; C++) {

                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws[cellRef];
                if (!cell) continue;

                if (!cell.s) cell.s = {};
                cell.s.border = borderStyle;
                cell.s.alignment = { horizontal: "center", vertical: "center" };

                // SUMMARY ROWS
                if (R < 6 && C === 0) {
                    cell.s.fill = summaryFill;
                    continue;
                }

                // HEADER ROW 1 (Row 7)
                if (R === 7) {
                    cell.s.fill = header1Fill;
                    continue;
                }

                // HEADER ROW 2 (Row 8)
                if (R === 8) {
                    cell.s.fill = header2Fill;
                    continue;
                }

                // DATA ROWS
                if (R > 8) {
                    cell.s.fill = dataFill;
                }
            }
        }

        // -------------------------
        // AUTO-FIT WIDTH FIRST SHEET
        // -------------------------
        const colWidths = [];
        rows.forEach(row => {
            row.forEach((val, i) => {
                const content = val ? val.toString() : "";
                const width = content.length + 4;

                // Limit column width to max 100
                const finalWidth = Math.min(width, 30);

                colWidths[i] = Math.max(colWidths[i] || 10, finalWidth);
            });
        });

        // Apply wrapping to all cells
        const rangeW = XLSX.utils.decode_range(ws["!ref"]);
        for (let R = rangeW.s.r; R <= rangeW.e.r; R++) {
            for (let C = rangeW.s.c; C <= rangeW.e.c; C++) {
                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws[cellRef];
                if (!cell) continue;

                if (!cell.s) cell.s = {};
                cell.s.alignment = { wrapText: true, horizontal: "center", vertical: "center" };
            }
        }

        // Assign width
        ws["!cols"] = colWidths.map(w => ({ wch: w }));

        // -----------------------------------------
        // SECOND SHEET — GRADIENT DETAILS
        // -----------------------------------------
        const gradientRows = [];
        gradientRows.push([
            "LINE NAME", "Gradient Details"
        ]);
        gradientRows.push([
            "", "From (ABS Value)", "To (ABS Value)", "Length", "Direction", "Grade (1 in N)"
        ]);

        const maxLines2 = Math.max(
            (currentStation.gradients?.length ?? 0),
            // (currentStation.psrs?.length ?? 0),
            1
        );

        for (let i = 0; i < maxLines2; i++) {
            const g = currentStation.gradients?.[i] ?? {};

            gradientRows.push([
                g.lines ?? "-",
                g.from_abs ?? "-",
                g.to_abs ?? "-",
                g.length ?? "-",
                g.direction ?? "-",
                g.grade ?? "-",
            ]);
        }

        const ws2 = XLSX.utils.aoa_to_sheet(gradientRows);

        ws2["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
            { s: { r: 0, c: 1 }, e: { r: 0, c: 5 } }
        ];

        // ---- STYLE SECOND SHEET ----
        const range2 = XLSX.utils.decode_range(ws2["!ref"]);

        for (let R = range2.s.r; R <= range2.e.r; R++) {
            for (let C = range2.s.c; C <= range2.e.c; C++) {

                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws2[cellRef];
                if (!cell) continue;

                if (!cell.s) cell.s = {};
                cell.s.border = borderStyle;
                cell.s.alignment = { horizontal: "center", vertical: "center" };

                if (R === 0) {
                    cell.s.fill = header1Fill;
                    continue;
                }

                if (R === 1) {
                    cell.s.fill = header2Fill;
                    continue;
                }

                cell.s.fill = dataFill;
            }
        }

        // Auto width second sheet
        const colWidths2 = [];
        gradientRows.forEach(row => {
            row.forEach((val, i) => {
                const content = val ? val.toString() : "";
                const width = content.length + 4;
                colWidths2[i] = Math.max(colWidths2[i] || 10, width);
            });
        });
        ws2["!cols"] = colWidths2.map(w => ({ wch: w }));






        // -------------------------------------------------------
        // THIRD SHEET — RFID TAG & TIN RANGE SUMMARY
        // -------------------------------------------------------
        const rfidRows = [];

        // HEADER
        rfidRows.push([
            "Station Name",
            "Station Code",
            "Station ID",
            "Division",
            "Zone",
            "Section",
            "Station Center Chainage in meters",
            "RFID TAG Range",
            "RFID TIN Range",
            "SIP Reference",
            "LAYOUT REFERENCE",
            "RCT REFERENCE",
            "ICT/TOC REFERENCE",
            "RFID TOC",
            "TD REFERENCE",
            "STATION HINDI NAME",
            "DIV-SECTION"
        ]);

        // DATA — include previous, current, next in same order as sheet1
        stationsToPrintInExcel.forEach(s => {
            rfidRows.push([
                s.name || "-",
                s.station_code || "-",
                s.station_id || "-",
                s.zone || "-",
                s.division || "-",
                s.section || "-",
                s.chainage || "-",
                s.tag_range ? s.tag_range.replace(/\|/g, ",") : "-",
                s.tin_range ? s.tin_range.replace(/\|/g, ",") : "-",
                s.sip_reference || "-",
                s.ref_layout || "-",
                s.ref_rct || "-",
                s.ref_toc || "-",
                s.rfid_toc || "-",
                s.ref_td || "-",
                s.name_hindi || "-",
                s.div_section || "-"
            ]);
        });

        // Create sheet
        const ws3 = XLSX.utils.aoa_to_sheet(rfidRows);

        // Basic styling + borders
        const range3 = XLSX.utils.decode_range(ws3["!ref"]);

        for (let R = range3.s.r; R <= range3.e.r; R++) {
            for (let C = range3.s.c; C <= range3.e.c; C++) {

                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws3[cellRef];
                if (!cell) continue;

                if (!cell.s) cell.s = {};
                cell.s.border = borderStyle;
                cell.s.alignment = { horizontal: "center", vertical: "center" };

                if (R === 0) {
                    cell.s.fill = header1Fill;   // first header row color
                } else {
                    cell.s.fill = dataFill;      // normal data color
                }
            }
        }

        // Auto column width
        const colWidths3 = [];
        rfidRows.forEach(row => {
            row.forEach((val, i) => {
                const content = val ? val.toString() : "";
                const width = content.length + 4;
                colWidths3[i] = Math.max(colWidths3[i] || 12, width);
            });
        });
        ws3["!cols"] = colWidths3.map(w => ({ wch: w }));


        // -------------------------
        // APPEND SHEETS + SAVE FILE
        // -------------------------
        XLSX.utils.book_append_sheet(wb, ws, "Station Information");
        XLSX.utils.book_append_sheet(wb, ws2, "Gradient Details");
        XLSX.utils.book_append_sheet(wb, ws3, "RFID TAG & TIN Ranges");

        XLSX.writeFile(wb, `Station_Info_${currentStation.name}.xlsx`);
    };

    const matchedStationIds = new Set(
        stations
            .filter(station =>
                station.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                station.station_id?.toString().includes(searchTerm)
            )
            .flatMap(station => [
                station.station_id,
                station.station_id - 1,
                station.station_id + 1
            ])
    );


    return (
        <>
            <Header />
            <div className="row mx-0 py-4 justify-content-center">
                <div className="col-md-10">
                    <div className="d-flex justify-content-between align-items-center mb-4 bg-white sticky-top">
                        <div className="">
                            <h1 className="h3 fw-bold text-dark mb-1">Stations Management</h1>
                            <p className="text-muted">Manage your Station Info files from here</p>
                        </div>
                        <div className="col-md-4">
                            <form autoComplete="off">
                                <input
                                    type="text"
                                    className="form-control shadow-sm border-4"
                                    placeholder="Search by Station Name or ID"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </form>
                        </div>

                        <button
                            className="btn d-flex align-items-center gap-2 shadow-sm"
                            onClick={() => setShowCreate(true)}
                            style={{
                                background: '#193e6c',
                                fontSize: '1rem',
                                color: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}

                        >
                            <i className="bi bi-plus-circle"></i>
                            Add New Station
                        </button>
                    </div>

                    {stations.length > 0 ? (
                        <div className="row g-4">
                            {stations
                                .filter(station => matchedStationIds.has(station.station_id))
                                .map((station) => {
                                    const maxRecords = Math.max(
                                        station.boundaries?.length || 0,
                                        station.atp_records?.length || 0,
                                        station.gradients?.length || 0,
                                        station.psrs?.length || 0,
                                        1
                                    );

                                    return (
                                        <div key={station.station_id} className="col-12">
                                            <div className="card shadow-sm border-2">
                                                {/* Station Header */}
                                                <div className="card-header bg-light d-flex justify-content-between align-items-center py-3">
                                                    <div>
                                                        <h5 className="fw-bold mb-0 text-primary-blue">{station.name} - {station.station_id} | {station.station_code} | {station.division} | {station.zone}</h5>
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            className="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                                                            onClick={() => exportSingleStation(station)}
                                                        >
                                                            <i className="bi bi-download"></i>
                                                            Export
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                                                            onClick={() => {
                                                                setSelectedStation(station);
                                                                setShowUpdate(true);
                                                            }}
                                                        >
                                                            <i className="bi bi-pencil"></i>
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                                                            onClick={() => {
                                                                setSelectedStation(station);
                                                                setShowDelete(true);
                                                            }}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="card-body p-2">
                                                    <div className="row g-4">
                                                        {/* Basic Info Column */}
                                                        <div className="col-md-2">
                                                            <div className="card h-100 border-0 bg-light">
                                                                <div className="card-body">
                                                                    <h6 className="fw-bold text-muted mb-3">
                                                                        <i className="bi bi-info-circle me-2"></i>
                                                                        Basic Info
                                                                    </h6>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">Section: <span className="fw-medium fs-6 text-black">{station.section || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">Chainage: <span className="fw-medium fs-6 text-black">{station.chainage || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">PSR Speed: <span className="fw-medium fs-6 text-black">{station.psrs?.[0]?.speed || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label text-muted small mb-1">TAG Range</label>
                                                                        <div className="fw-medium">{station.tag_range || <span className="text-muted">-</span>}</div>
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label text-muted small mb-1">TIN Range</label>
                                                                        <div className="fw-medium">{station.tin_range || <span className="text-muted">-</span>}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Ref Column */}
                                                        <div className="col-md-3">
                                                            <div className="card h-100 border-0 bg-light">
                                                                <div className="card-body">
                                                                    <h6 className="fw-bold text-muted mb-3">
                                                                        <i className="bi bi-file-earmark me-2"></i>
                                                                        Reference Files
                                                                    </h6>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">Hindi: <span className="fw-medium fs-6 text-black">{station.name_hindi || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">SIP ref: <span className="fw-medium fs-6 text-black">{station.sip_reference || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">ICT/TOC: <span className="fw-medium fs-6 text-black">{station.ref_toc || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">RFID TOC: <span className="fw-medium fs-6 text-black">{station.rfid_toc || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">Layout: <span className="fw-medium fs-6 text-black">{station.ref_layout || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">TD: <span className="fw-medium fs-6 text-black">{station.ref_td || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                    <div className="">
                                                                        <label className="form-label text-muted small mb-1">Div-Section: <span className="fw-medium fs-6 text-black">{station.div_section || <span className="text-muted">-</span>}</span></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* ATP Territory Column */}
                                                        <div className="col-md-2">
                                                            <div className="card h-100 border-0 bg-light">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-bold text-muted mb-3 d-flex align-items-center">
                                                                        <i className="bi bi-diagram-3 me-2"></i>
                                                                        ATP Territory
                                                                    </h6>
                                                                    {station.atp_records?.length > 0 ? (
                                                                        <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                                                            <table className="table table-sm table-hover mb-0">
                                                                                <thead className="bg-white sticky-top">
                                                                                    <tr>
                                                                                        <th className="text-muted small border-bottom">Entry/Exit</th>
                                                                                        <th className="text-muted small border-bottom">Signal</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {station.atp_records.map((atp, idx) => (
                                                                                        <tr key={idx} className="border-bottom">
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{atp.entry_exit || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{atp.signal_name || "-"}</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-center text-muted py-4">
                                                                            <i className="bi bi-x-circle fs-4"></i>
                                                                            <p className="mb-0 mt-2 small">No ATP records</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Boundaries Column */}
                                                        <div className="col-md-2">
                                                            <div className="card h-100 border-0 bg-light">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-bold text-muted mb-3 d-flex align-items-center">
                                                                        <i className="bi bi-border-all me-2"></i>
                                                                        Boundaries
                                                                    </h6>
                                                                    {station.boundaries?.length > 0 ? (
                                                                        <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                                                            <table className="table table-sm table-hover mb-0">
                                                                                <thead className="bg-white sticky-top">
                                                                                    <tr>
                                                                                        <th className="text-muted small border-bottom">Line</th>
                                                                                        <th className="text-muted small border-bottom">Signal</th>
                                                                                        <th className="text-muted small border-bottom">Type</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {station.boundaries.map((boundary, idx) => (
                                                                                        <tr key={idx} className="border-bottom">
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{boundary.line_name || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{boundary.signal_name || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{boundary.signal_type || "-"}</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-center text-muted py-4">
                                                                            <i className="bi bi-x-circle fs-4"></i>
                                                                            <p className="mb-0 mt-2 small">No boundaries</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3">
                                                            <div className="card h-100 border-0 bg-light">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-bold text-muted mb-3 d-flex align-items-center">
                                                                        <i className="bi bi-graph-up me-2"></i>
                                                                        Gradients
                                                                    </h6>
                                                                    {station.gradients?.length > 0 ? (
                                                                        <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                                                            <table className="table table-sm table-hover mb-0">
                                                                                <thead className="bg-white sticky-top">
                                                                                    <tr>
                                                                                        <th className="text-muted small border-bottom">Lines</th>
                                                                                        <th className="text-muted small border-bottom">From</th>
                                                                                        <th className="text-muted small border-bottom">To</th>
                                                                                        <th className="text-muted small border-bottom">Length</th>
                                                                                        <th className="text-muted small border-bottom">Grade</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {station.gradients.map((gradient, idx) => (
                                                                                        <tr key={idx} className="border-bottom">
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{gradient.lines || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{gradient.from_abs || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{gradient.to_abs || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium">{gradient.length || "-"}</span>
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                <span className="fw-medium text-primary">{gradient.grade || "-"}</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-center text-muted py-4">
                                                                            <i className="bi bi-x-circle fs-4"></i>
                                                                            <p className="mb-0 mt-2 small">No gradients</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Summary Row */}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    ) : (
                        <div className="card border-0 shadow-sm">
                            <div className="card-body text-center py-5">
                                <div className="mb-4">
                                    <i className="bi bi-train-front fs-1 text-muted"></i>
                                </div>
                                <h4 className="text-muted mb-3">No Stations Found</h4>
                                <p className="text-muted mb-4">Get started by adding your first railway station</p>
                                <button
                                    className="btn btn-primary btn-lg"
                                    onClick={() => setShowCreate(true)}
                                >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Create First Station
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Modals */}
                    {showCreate && (
                        <CreateInfoStationModal onClose={() => setShowCreate(false)} onCreated={fetchStations} />
                    )}
                    {showUpdate && (
                        <UpdateInfoStationModal
                            station={selectedStation}
                            onClose={() => setShowUpdate(false)}
                            onUpdated={fetchStations}
                        />
                    )}
                    {showDelete && (
                        <DeleteInfoStationModal
                            station={selectedStation}
                            onClose={() => setShowDelete(false)}
                            onDeleted={fetchStations}
                        />
                    )}
                </div>
            </div>
        </>
    );


    //   return (
    //     <div className="container mt-5">
    //       <h2 className="text-center mb-4">Station Management</h2>

    //       <div className="d-flex justify-content-end mb-3 gap-2">
    //         <button className="btn btn-success" onClick={() => setShowCreate(true)}>
    //           + Add Station
    //         </button>
    //       </div>

    //       <div className="table-responsive">
    //         <table className="table table-bordered align-middle text-center" style={{ fontSize: '0.85rem' }}>
    //           <thead>
    //             <tr className="table-danger text-white">
    //               <th rowSpan={2}>NAME</th>
    //               <th rowSpan={2}>STATION ID</th>
    //               <th rowSpan={2}>STATION CODE</th>
    //               <th rowSpan={2}>CHAINAGE</th>
    //               <th rowSpan={2}>GRADIENT<br />STATUS</th>
    //               <th colSpan={2}>ATP TERRITORY</th>
    //               <th colSpan={3}>BOUNDARY</th>
    //               <th colSpan={6}>GRADIENT</th>
    //               <th rowSpan={2}>PSR<br />SPEED</th>
    //               <th rowSpan={2}>TAG<br />RANGE</th>
    //               <th rowSpan={2}>TIN<br />RANGE</th>
    //               <th rowSpan={2}>Actions</th>
    //             </tr>
    //             <tr className="table-warning">
    //               <th>Entry/Exit</th>
    //               <th>Signal</th>
    //               <th>Line</th>
    //               <th>Signal</th>
    //               <th>Type</th>
    //               <th>Lines</th>
    //               <th>From</th>
    //               <th>To</th>
    //               <th>Length</th>
    //               <th>Dir</th>
    //               <th>Grade</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             {stations.length > 0 ? (
    //               stations.map((s) => {
    //                 const maxLines = Math.max(
    //                   (s.boundaries?.length ?? 0),
    //                   (s.atp_records?.length ?? 0),
    //                   (s.gradients?.length ?? 0),
    //                   (s.psrs?.length ?? 0),
    //                   1
    //                 );

    //                 return Array.from({ length: maxLines }, (_, i) => {
    //                   const b = s.boundaries?.[i] ?? {};
    //                   const a = s.atp_records?.[i] ?? { entry_exit: "", signal_name: "" };
    //                   const g = s.gradients?.[i] ?? {};
    //                   const p = s.psrs?.[i] ?? {};

    //                   return (
    //                     <tr key={`${s.station_id}-${i}`}>
    //                       {i === 0 && <td rowSpan={maxLines}>{s.name}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.station_id}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.station_code}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.chainage ?? ""}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.gradient_status ?? ""}</td>}

    //                       <td>{a.entry_exit || "-"}</td>
    //                       <td>{a.signal_name || "-"}</td>

    //                       <td>{b.line_name || ""}</td>
    //                       <td>{b.signal_name || ""}</td>
    //                       <td>{b.signal_type || ""}</td>

    //                       <td>{g.lines || ""}</td>
    //                       <td>{g.from_abs ?? ""}</td>
    //                       <td>{g.to_abs ?? ""}</td>
    //                       <td>{g.length ?? ""}</td>
    //                       <td>{g.direction || ""}</td>
    //                       <td>{g.grade || ""}</td>

    //                       {i === 0 && <td rowSpan={maxLines}>{p.speed || "-"}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.tag_range || "-"}</td>}
    //                       {i === 0 && <td rowSpan={maxLines}>{s.tin_range || "-"}</td>}

    //                       {i === 0 && (
    //                         <td rowSpan={maxLines}>
    //                           <button
    //                             className="btn btn-success btn-sm me-2"
    //                             onClick={() => exportSingleStation(s)}
    //                           >
    //                             Download
    //                           </button>
    //                           <button
    //                             className="btn btn-primary btn-sm me-2"
    //                             onClick={() => {
    //                               setSelectedStation(s);
    //                               setShowUpdate(true);
    //                             }}
    //                           >
    //                             Edit
    //                           </button>
    //                           <button
    //                             className="btn btn-danger btn-sm"
    //                             onClick={() => {
    //                               setSelectedStation(s);
    //                               setShowDelete(true);
    //                             }}
    //                           >
    //                             Delete
    //                           </button>
    //                         </td>
    //                       )}
    //                     </tr>
    //                   );
    //                 });
    //               }).flat()
    //             ) : (
    //               <tr><td colSpan="20">No stations found</td></tr>
    //             )}
    //           </tbody>
    //         </table>
    //       </div>

    //       {/* Modals */}
    //       {showCreate && (
    //         <CreateInfoStationModal onClose={() => setShowCreate(false)} onCreated={fetchStations} />
    //       )}
    //       {showUpdate && (
    //         <UpdateInfoStationModal
    //           station={selectedStation}
    //           onClose={() => setShowUpdate(false)}
    //           onUpdated={fetchStations}
    //         />
    //       )}
    //       {showDelete && (
    //         <DeleteInfoStationModal
    //           station={selectedStation}
    //           onClose={() => setShowDelete(false)}
    //           onDeleted={fetchStations}
    //         />
    //       )}
    //     </div>
    //   );


};

export default StationInfoScreen;